import { SidebarNavigationDesktop } from '../_base/sidebar_navigation/desktop/SidebarNavigationDesktop';
import { DiffusionModelsTabUD } from './tabs/diffusion_models_tab_ud';

export function PageDiffusionModelsViewsDesktop() {
  /*
   * EVENTS
   */

  /*
   * EFFECTS
   */

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  return (
    <div className="w-full relative flex h-screen text-center">
      <SidebarNavigationDesktop />

      <DiffusionModelsTabUD />
    </div>
  );
}
